import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SearchRoutingModule } from './search-routing.module';
import { SearchComponent } from './search.component';
import { BzFAQModule, BzHelpCenterModule, BzPharmacyInfoModule, BzProductModule } from '../../modules-ui';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from '@shared';
import { BzSpinnerModule } from '../../modules-ui/blocks-ui/bz-spinner/spinner.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { StaticFooterModule } from 'src/app/modules-ui/layouts';
import { BzPricesTableModule } from 'src/app/modules-ui/blocks-ui/bz-prices-table/bz-prices-table.module';
import { BzInstructionAuthorModule } from 'src/app/modules-ui/blocks-ui/bz-instruction-editor/bz-instruction-author.module';
import { BzTownsListModule } from 'src/app/modules-ui/blocks-ui/bz-towns-list/bz-towns-list.module';


@NgModule({
  declarations: [SearchComponent],
  imports: [
    CommonModule,
    SearchRoutingModule,
    BzProductModule,
    TranslocoModule,
    StaticFooterModule,
    SharedModule,
    BzSpinnerModule,
    NgxPaginationModule,
    BzPricesTableModule,
    BzHelpCenterModule,
    BzFAQModule,
    BzInstructionAuthorModule,
    BzPharmacyInfoModule,
    BzTownsListModule
  ]
})
export class SearchModule { }
